import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { PrivateRoute } from '~/components/general';
import { LoginPage, HomePage } from '~/pages/general';

const Router = React.memo(() => (
  <BrowserRouter>
    <Switch>
      <Route path={`/login`} component={LoginPage} />
      <PrivateRoute path={`/home`} component={HomePage} />
      <Redirect path="/" to={`/home`} />
    </Switch>
  </BrowserRouter>
));

export default Router;
